import { useSelector } from 'react-redux';
import { useEffect } from 'react';

const loadHeap = (appId) => {
  window.heap = window.heap || [];
  window.heap.appid = appId;

  const scriptElement = document.createElement('script');
  scriptElement.id = 'heap';
  scriptElement.type = 'text/javascript';
  scriptElement.async = true;
  scriptElement.src = `https://www.aexp-static.com/cdaas/banking/business-checking/assets/heap-${appId}.js`;
  const firstScriptElement = document.querySelectorAll('script')[0];
  firstScriptElement.parentNode.insertBefore(scriptElement, firstScriptElement);
};

const useHeapAnalytics = () => {
  const { heapAppId } = useSelector((state) => state.get('config').toJS());

  const isBrowser = global.BROWSER;

  useEffect(() => {
    if (heapAppId && isBrowser) {
      loadHeap(heapAppId);
    }
  }, [heapAppId, isBrowser]);
};

export default useHeapAnalytics;
